exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-data-table[data-v-61d668fd] header {\n  font-size: 0.8em;\n  font-weight: 100;\n  text-transform: capitalize;\n}\n.v-text-field[data-v-61d668fd] input {\n  font-size: 0.8em;\n  font-weight: 100;\n  text-transform: capitalize;\n}\n", ""]);

// exports
